import
{
    useModifySystemShareNotifications,
    useSystem,
    useSystemNotifications,
    useSystemShareNotifications
} from '../../../../../../../ReactData/system';

import
{
    useUserNotifications,
    useUserPermissions
} from '../../../../../../../ReactData/user';

import
{
    Props
} from './types';

import
{
    LicenseType,
    NotificationChannel,
    permissionAllowed,
    SystemShareNotifications
} from '@ews/react-data';

import { useL10n } from '@ews/react-localization-context';
import { IonButton, IonItem } from '@ionic/react';
import { useHasLicense } from '../../../../../../../HasLicense';
import { useMyPermissions } from '../../../../../../../Login/LoginProvider';
import { useIsMobile } from '../../../../../../../Responsive';
import SettingsCol from '../../../../../../../Settings/SettingsCol/SettingsCol';
import SettingsCheckbox from '../../../../../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox';
import NotificationTable from '../components/NotificationsTable/NotificationsTable';
import NumberRange from '../components/NumberRange';


const Push: React.FC<Props> = ({ systemId, userId }) =>
{

    function setValues(status: boolean)
    {
        const val = status ? NotificationChannel.PUSH | NotificationChannel.EMAIL : NotificationChannel.NONE;

        return {
            fireAlarm: val,
            fireAlert: val,
            preAlarm: val,
            testScenario: val,
            testCondition: val,
            testActivation: val,
            testAlarm: val,
            activeOutput: val,
            fault: val,
            technicalMessage: val,
            disablement: val,
            extinguishingEvent: val,
            status: val,
        };
    }

    const notifications = useSystemShareNotifications(systemId || "", userId!);
    const { translate: t } = useL10n();
    const userNotifications = useUserNotifications(userId || "");
    const systemNotifications = useSystemNotifications(systemId || "");
    const system = useSystem(systemId || "");
    const myPermissions = useMyPermissions();

    const mobileView = useIsMobile();

    const userPermissions = useUserPermissions(userId || "");

    const hasOperateAndNotification = useHasLicense(LicenseType.OPERATE_AND_NOTIFICATION, userId);

    const allowedToEdit = permissionAllowed(myPermissions.createShare || 0);

    const modify = useModifySystemShareNotifications();
    const modifyData = async (data: SystemShareNotifications) => await modify(systemId!, userId!, data);

    const setFlag = (key: keyof SystemShareNotifications, type: keyof typeof NotificationChannel, value: boolean) =>
    {
        if (value) {
            (notifications[key] as NotificationChannel) = (notifications[key] as NotificationChannel) | NotificationChannel[type];
        } else {
            (notifications[key] as NotificationChannel) = (notifications[key] as NotificationChannel) & ~NotificationChannel[type];
        }
        return notifications;

    };

    return <>

        <SettingsCol>
            <NotificationTable
                disabled={!allowedToEdit}
                notification={notifications}
                title='TD_FREIGABE'
                onCheck={(v) =>
                {
                    modifyData(setFlag(v.key, v.type, v.value));
                }}
            />
            <IonItem lines='none'>
                <div style={{ width: "100%" }}>
                    <IonButton
                        disabled={!allowedToEdit}
                        color={"success"}
                        expand={"full"}
                        onClick={() =>
                        {
                            const allValues = setValues(true);
                            modifyData(allValues as SystemShareNotifications);

                        }}>{t("TD_GROSS_ALLE")}</IonButton>
                </div>
            </IonItem>
            <IonItem>
                <div style={{ width: "100%" }}>
                    <IonButton
                        disabled={!allowedToEdit}
                        color={"danger"}
                        expand={"full"}
                        onClick={() =>
                        {
                            const defaultValues = setValues(false);
                            modifyData(defaultValues as SystemShareNotifications);

                        }}>{t("TPL_BEEZ3_RESET")}</IonButton>
                </div>
            </IonItem>
        </SettingsCol >
        <SettingsCol>
            <NotificationTable
                notification={systemNotifications}
                title='[SID_MNU_TAB_INFO_SCR]'
                disabled
                onCheck={(v) => console.log(v)}
            />
        </SettingsCol >
        <SettingsCol>
            <NotificationTable
                notification={userNotifications}
                title='TD_USERNAME'
                disabled
                onCheck={(v) => console.log(v)}
            />

        </SettingsCol >

        <SettingsCol>

            <NumberRange
                disabled={!allowedToEdit}
                label='[SID_MNU_TAB_GROUPS]'
                from={notifications.fromZone}
                to={notifications.toZone}
                onChange={(fromZone, toZone) => modifyData({ fromZone, toZone } as SystemShareNotifications)}
            />

            <NumberRange
                disabled={!allowedToEdit}
                label='[SID_MNU_TAB_CONTROLS]'
                from={notifications.fromActuation}
                to={notifications.toActuation}
                onChange={(fromActuation, toActuation) => modifyData({ fromActuation, toActuation } as SystemShareNotifications)}
            />

            <NumberRange
                disabled={!allowedToEdit}
                label='[REACT_ALARMINGDEVICE]'
                from={notifications.fromAlarmingDevice}
                to={notifications.toAlarmingDevice}
                onChange={(fromAlarmingDevice, toAlarmingDevice) => modifyData({ fromAlarmingDevice, toAlarmingDevice } as SystemShareNotifications)}
            />
            <NumberRange
                disabled={!allowedToEdit}
                label='[REACT_TRANSMISSIONDEVICE]'
                from={notifications.fromTransmissionDevice}
                to={notifications.toTransmissionDevice}
                onChange={(fromTransmissionDevice, toTransmissionDevice) => modifyData({ fromTransmissionDevice, toTransmissionDevice } as SystemShareNotifications)}
            />
            {system.hasFloodingZone ? <>

                <NumberRange
                    disabled={!allowedToEdit}
                    label='COM_FACPMANAGEMENT_SHARE_FIELD_VIEW_FL_FZ_LABEL'
                    from={notifications.fromFloodingZone}
                    to={notifications.toFloodingZone}
                    onChange={(fromFloodingZone, toFloodingZone) => modifyData({ fromFloodingZone, toFloodingZone } as SystemShareNotifications)}
                />
            </> : <></>}
        </SettingsCol >
        <SettingsCol >

            {mobileView ?

                <IonItem style={{
                    margin: "0 0 15px 0"
                }}
                    color={"primary"}>
                    <div style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "2rem",
                        fontWeight: "bolder",
                    }}>
                        {`${t("COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS")}`}
                    </div>
                </IonItem>
                :
                null
            }

            <SettingsCheckbox
                disabled
                label={false}
                textElement
                text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_CONSTRUCTIONSPUSHLOWERLEVEL"}
                checked={permissionAllowed(userPermissions.notifyAllSystem || 0)} />
            <SettingsCheckbox
                disabled
                label={false}
                textElement
                text={"COM_FACPMANAGEMENT_USER_ACCOUNT_LICENCE"}
                checked={hasOperateAndNotification} />


        </SettingsCol >
    </>;
};
export default Push;
